import {portalLocationApi} from '@/portal/api/locationApi';

/**
 * Логика модального окна смены населенного пункта.
 */
export default function initLocationModal({api = portalLocationApi, debounceDelay = 400} = {}) {
    const modal = document.getElementById('modalChangeLocation');
    if (!modal) {
        return;
    }

    const regionSelect = modal.querySelector('#regionSelect');
    const resultsContainer = modal.querySelector('#searchResults');
    const addressInput = modal.querySelector('#address');
    const searchLoading = modal.querySelector('#searchLoading');

    if (!regionSelect || !resultsContainer || !addressInput || !searchLoading) {
        return;
    }

    let delayTimer = null;
    let inFlightController = null;

    modal.addEventListener('show.bs.modal', () => {
        cancelSearch();
        addressInput.value = '';
        resultsContainer.innerHTML = '';
    });

    modal.addEventListener('shown.bs.modal', () => {
        addressInput.focus();
    });

    modal.addEventListener('hide.bs.modal', cancelSearch);

    addressInput.addEventListener('input', () => {
        const regionCode = regionSelect.value;
        const query = addressInput.value;

        resultsContainer.innerHTML = '';
        cancelSearch();

        if (query.trim().length < 3) {
            return;
        }

        searchLoading.style.display = 'block';

        delayTimer = setTimeout(() => {
            delayTimer = null;
            const requestController = new AbortController();
            inFlightController = requestController;

            api.searchCities(regionCode, query, requestController.signal)
                .then((data) => {
                    if (inFlightController === requestController) {
                        renderResults(data);
                    }
                })
                .catch((error) => {
                    if (error.name === 'AbortError') {
                        return;
                    }
                    console.error('Ошибка при запросе подсказок города', error);
                })
                .finally(() => {
                    if (inFlightController === requestController) {
                        inFlightController = null;
                        searchLoading.style.display = 'none';
                    }
                });
        }, debounceDelay);
    });

    function cancelSearch() {
        if (delayTimer) {
            clearTimeout(delayTimer);
            delayTimer = null;
        }
        if (inFlightController) {
            inFlightController.abort();
            inFlightController = null;
        }
        searchLoading.style.display = 'none';
    }

    function renderResults(list) {
        resultsContainer.innerHTML = '';
        list.forEach((result) => {
            const item = document.createElement('p');
            item.classList.add('link');
            item.textContent = result.value ?? '';
            item.addEventListener('click', () => submitLocationForm(result));
            resultsContainer.appendChild(item);
        });
    }

    function submitLocationForm(result) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/save-locate';

        appendHiddenInput(form, '_token', getCsrfToken());
        appendHiddenInput(form, 'region', result.region);
        appendHiddenInput(form, 'area', result.area);
        appendHiddenInput(form, 'city', result.city);
        appendHiddenInput(form, 'coords[0]', result.coords?.[0] ?? '');
        appendHiddenInput(form, 'coords[1]', result.coords?.[1] ?? '');

        document.body.appendChild(form);
        form.submit();
    }

    function appendHiddenInput(form, name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    function getCsrfToken() {
        if (window.csrf_token) {
            return window.csrf_token;
        }
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.getAttribute('content') : '';
    }
}
